<template>
  <div class="ai-chat-input-wrapper">
    <div class="input-divider"></div>
    <div class="input-container">
      <div class="input-box">
        <textarea
          ref="textarea"
          v-model="inputText"
          class="chat-textarea"
          :placeholder="placeholder"
          :disabled="disabled"
          @keydown.enter.exact.prevent="handleSend"
          @input="handleInput"
          rows="4"
        ></textarea>
        <!-- Original:
        <Button 
          colorType="dark-blue" 
          :disabled="!canSend || disabled"
          @click="handleSend" 
          class="send-button"
        >
          <div style = "display: flex; align-items: center; gap: 4px;">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M17.27 6.73L13.03 16.86L11.39 12.61L10.57 12.29L7.14 10.96L17.27 6.73ZM21 3L3 10.53V11.51L9.84 14.16L12.48 21H13.46L21 3Z" fill="white"/>
            </svg>
            Send
          </div>
        </Button>
        -->
        <ResponsiveButton
          display_name="Send"
          button_type="filled"
          built_in_theme="dark"
          size="small"
          button_border_radius="100px"
          :disabled="!canSend || disabled"
          @click-button="handleSend"
        >
          <template #prefix>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M17.27 6.73L13.03 16.86L11.39 12.61L10.57 12.29L7.14 10.96L17.27 6.73ZM21 3L3 10.53V11.51L9.84 14.16L12.48 21H13.46L21 3Z" fill="white"/>
            </svg>
          </template>
        </ResponsiveButton>
      </div>
    </div>
  </div>
</template>

<script>
// Original: import Button from '@/NewLibrary/Button.vue';
// Replaced with globally registered ResponsiveButton from @vibrant-wellness/va-responsive-components-library
export default {
  name: 'AIChatInput',
  components: {
    // Button, // replaced by globally registered ResponsiveButton
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Ask anything about Workflow'
    }
  },
  data() {
    return {
      inputText: ''
    };
  },
  computed: {
    canSend() {
      return this.inputText.trim().length > 0;
    }
  },
  emits: ['send-message'],
  methods: {
    handleInput() {
      this.$nextTick(() => {
        const textarea = this.$refs.textarea;
        if (textarea) {
          textarea.style.height = 'auto';
          textarea.style.height = `${Math.min(textarea.scrollHeight, 80)}px`;
        }
      });
    },
    handleSend() {
      if (this.canSend && !this.disabled) {
        const text = this.inputText.trim();
        this.$emit('send-message', { text });
        this.inputText = '';
        this.$nextTick(() => {
          const textarea = this.$refs.textarea;
          if (textarea) {
            textarea.style.height = 'auto';
          }
        });
      }
    }
  }
};
</script>

<style scoped>
.ai-chat-input-wrapper {
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  flex-shrink: 0;
}

.input-divider {
  padding: 0px 16px;
  width: 100%;
  height: 1px;
  background: #C4C4C4;
  background-clip: content-box;
}

.input-container {
  display: flex;
  flex-direction: column;
  padding: 0 24px;
}

.input-box {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-end;
  background: #FFFFFF;
  border: 1px solid #C4C4C4;
  border-radius: 8px;
  padding: 12px 16px;
}

.chat-textarea {
  width: 100%;
  min-height: 80px;
  max-height: 80px;
  border: none;
  outline: none;
  resize: none;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #333;
  overflow-y: auto;
}

.chat-textarea::placeholder {
  color: #999;
}

.chat-textarea:disabled {
  background: transparent;
  cursor: not-allowed;
  color: #999;
}

.send-button {
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
  height: 32px;
  padding: 4px 16px;

  border: none;
  border-radius: 100px;
  box-shadow: 0px 1px 3px 0px rgba(74, 74, 74, 0.25);
  cursor: pointer;
  transition: all 0.2s ease;
}

.send-button:disabled {
  background: #C4C4C4;
  cursor: not-allowed;
}

.send-button svg {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}

.send-button span {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1px;
  color: #FFFFFF;
  text-align: center;
}

.send-button:not(.active) svg,
.send-button:not(.active) span {
  color: #FFFFFF;
}
</style>
